module.exports = __webpack_public_path__ + "static/team-on-sofa-52c54bf75736d6e5399a8e599490b434.svg";